module.exports = __webpack_public_path__ + "img/boky_81_seda.ccc7fa7a.png";